module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraLight.90da5cb.ttf";